export default __webpack_public_path__ + "static/smoke_detector_b.7d9f922651fdd5495fd4ec5bf9626a7f.svg";